/* MkaeSense glass layer: pointer light, two-tone headlines, scroll reveals */
(function(){
'use strict';
var D=document;
function ready(f){if(D.readyState==='loading')D.addEventListener('DOMContentLoaded',f);else f();}
ready(function(){
var main=D.querySelector('main');
if(!main)return;
/* two-tone headlines: last sentence goes grey */
function tone(el){
if(!el||el.querySelector('.mk-tail')||el.children.length)return;
var t=(el.textContent||'').trim(),m=t.match(/[^.!?]+[.!?]+/g);
if(!m||m.length<2||m.join('').length<t.length-1)return;
var tail=m.pop().trim(),lead=m.join('').trim();
el.textContent='';
el.appendChild(D.createTextNode(lead+' '));
var s=D.createElement('span');s.className='mk-tail';s.textContent=tail;el.appendChild(s);
}
tone(D.querySelector('.hero-wrapper p'));
[].forEach.call(D.querySelectorAll('[class*="ai-cinema-hero-"][class*="__title"]'),tone);
/* pointer light on glass surfaces */
var sel='.mk-cat__link,.mk-stat,[class*="ai-security-features-"][class*="__card"],[class*="ai-why-security-"][class*="__card"]';
[].forEach.call(D.querySelectorAll(sel),function(e){e.classList.add('mk-glow');});
D.addEventListener('pointermove',function(e){
var c=e.target&&e.target.closest?e.target.closest('.mk-card,.mk-glow'):null;if(!c)return;
var r=c.getBoundingClientRect();c.style.setProperty('--mx',(e.clientX-r.left)+'px');c.style.setProperty('--my',(e.clientY-r.top)+'px');
},{passive:true});
/* scroll-driven reveals (CSS does the work where supported) */
if(main.getAttribute('data-template')==='index'){
['.mk-cats__head','.mk-fx-head','.mk-board','.mk-stats','.ui-test-product-list h3','[class*="ai-security-features-"][class*="__heading"]','[class*="ai-why-security-"][class*="__heading"]','[class*="ai-cinema-hero-"][class*="__content"]'].forEach(function(s){
[].forEach.call(D.querySelectorAll(s),function(e){e.classList.add('mk-sd');});
});
}
});
})();